import React from "react";
import { connect } from "react-redux";
import RequestModal from "./RequestModal";
import operations from "./ducks/operations";
import compOperations from "../comp/ducks/operations";
import { withRouter } from "react-router-dom";

const RequestModalContainer = (props) => {
    return <RequestModal {...props} autocompleteResults={props.autocompleteResults} />;
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
        isLoading: state.utilsReducer.isLoading,
        searchResults: state.searchReducer.autocompleteResults,
        autocompleteResults: state.searchReducer.autocompleteResults,
        requestModal: state.listingReducer.requestModal,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        selectProperty: (property) => {
            dispatch(operations.getPropertyForListingCreation(property));
        },
        removeSelectedProperty: () => {
            dispatch(operations.removeSelectedPropertyFromRequestModal());
        },
        updateListingRequest: (field, value) => {
            dispatch(operations.updateListingRequest(field, value));
        },
        requestListing: async (modalType, transactionType, propertyType, tab, role) => {
            const { history } = ownProps;
            let result = undefined;
            switch (modalType) {
                case "listing":
                    if (tab === "existing") {
                        result = await dispatch(operations.requestListing());
                    } else {
                        result = await dispatch(operations.requestListingNewProperty());
                    }
                    if (result) {
                        if (result.entityKey) {
                            history.push(`/listing/${result.entityKey}`);
                        }
                    }
                    break;
                case "appraisal":
                    result = await dispatch(
                        compOperations.addOutsideComp(transactionType, propertyType, tab === "new", "Appraisal Draft")
                    );
                    if (result) {
                        if (result.entityKey) {
                            if (transactionType === "Consulting") {
                                history.push(`/voucher/${result.entityKey}`);
                            } else {
                                history.push(`/comp/${result.entityKey}`);
                            }
                        }
                    }
                    break;
                case "outside-comp":
                    result = await dispatch(
                        compOperations.addOutsideComp(transactionType, propertyType, tab === "new", "Outside Draft")
                    );
                    if (result) {
                        if (result.entityKey) {
                            history.push(`/comp/${result.entityKey}`);
                        }
                    }
                    break;
                case "internal-comp":
                    result = await dispatch(
                        compOperations.addOutsideComp(transactionType, propertyType, tab === "new", "Draft")
                    );
                    if (result) {
                        if (result.entityKey) {
                            if (transactionType === "Consulting") {
                                history.push(`/voucher/${result.entityKey}`);
                            } else {
                                history.push(`/comp/${result.entityKey}`);
                            }
                        }
                    }
                    break;
                default:
                    break;
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RequestModalContainer));
